import { PropertiesTableProps } from '../../shared/types'
import { ParagraphProperties } from './PDocs'

export const LeadProperties: PropertiesTableProps = {
  ...ParagraphProperties,
}
